import { CourseLvcUserFacingStatus } from 'views/Catalog/useCourseLiveClassInfo';
import { LandingTab } from 'components/Landing/types';
import {
  BodyRowType,
  IconLabel,
  IconType,
  OfferingTypeConfig,
} from '../utils/types';
import {
  formatProductRows,
  getLiveVirtualClassRows,
} from '../BodyBuilder/utils';
import { livePremiumSessionCourseIconConfig } from './livePremiumSessionCourse';
import { courseIconConfig } from './course';

const liveVirtualClassConfig: OfferingTypeConfig = {
  actionButtons: ({
    displayProgress,
    entry,
    hasProgress,
    isLocked,
    lvcInfo,
    catalogStore,
    routerStore,
    t,
  }) => {
    const link = catalogStore.getCatalogEntryLink(entry, { hasProgress });
    if (!link) {
      return {};
    }

    const actionButtonA = {
      buttonLabel: displayProgress ? t('Continue') : t('View'),
      href: link.href,
      icon: IconType.Arrow,
      onClick: link.navigate,
    };

    if (isLocked) {
      return { actionButtonA };
    }

    const isOngoing = lvcInfo?.lvcStatus === CourseLvcUserFacingStatus.Ongoing;

    const buttonBRouteName = isOngoing ? 'classes:view' : 'courses:overview';
    const buttonBRouteParams = isOngoing
      ? { uuid: lvcInfo.lvcUuid }
      : {
          course: `${entry.code}-${entry.version}`,
          tab: LandingTab.LiveClass,
        };

    const actionButtonB = {
      buttonLabel: isOngoing ? t('Attend') : t('Go to class'),
      href: routerStore.router.buildUrl(buttonBRouteName, buttonBRouteParams),
      icon: IconType.Arrow,
      onClick: () => routerStore.navigate(buttonBRouteName, buttonBRouteParams),
    };

    return { actionButtonA, actionButtonB };
  },
  bodyRowsLayout: ({ lvcStatus }) => {
    if (
      lvcStatus === CourseLvcUserFacingStatus.Enrolled ||
      lvcStatus === CourseLvcUserFacingStatus.Ongoing
    ) {
      return [BodyRowType.Custom];
    }
    return [BodyRowType.Icons, BodyRowType.Custom];
  },
  buildCustomRows: ({
    liveVirtualClassInfo,
    lvcStatus,
    offeringProducts,
    t,
    userTimezone,
  }) => {
    if (lvcStatus === CourseLvcUserFacingStatus.Available)
      return formatProductRows(offeringProducts);
    return getLiveVirtualClassRows(
      lvcStatus,
      liveVirtualClassInfo,
      t,
      userTimezone,
    );
  },
  headerConfig: ({ t }) => ({
    iconA: courseIconConfig,
    iconB: livePremiumSessionCourseIconConfig,
    title: t('Course'),
  }),
  iconRowsLayout: () => [[IconLabel.Duration, IconLabel.Level]],
};

export default liveVirtualClassConfig;
